import { formatDistanceToNow } from 'date-fns';

/**
 * Format a last_active_at timestamp into a human-readable "last seen" string.
 *
 * @param lastActiveAt - ISO timestamp string or null
 * @returns Formatted string like "Online", "Active just now", "Last seen 5 minutes ago"
 */
export function formatLastSeen(lastActiveAt: string | null): string {
  if (!lastActiveAt) {
    return 'Offline';
  }

  const date = new Date(lastActiveAt);
  const now = new Date();
  const diffInMinutes = (now.getTime() - date.getTime()) / (1000 * 60);

  // If less than 2 minutes, consider as "just now"
  if (diffInMinutes < 2) {
    return 'Active just now';
  }

  // Otherwise show relative time
  return `Last seen ${formatDistanceToNow(date, { addSuffix: true })}`;
}
